<template>
  <div class="payment-page container py-4">
    
    <h3 class="mb-3">{{t('payment_page.page_title')}}</h3>
    <!-- Iframe -->
    <div v-if="loading" class="loader">
      {{ t('common.Loading') }}
    </div>
    <iframe
      v-show="!loading"
      ref="paymentIframe"
      :src="iframeUrl"
      width="100%"
      height="600"
      frameborder="0"
      @load="onIframeLoad"
    ></iframe>
    <!-- Error -->
    <div v-if="error" class="alert alert-danger mt-3">
      {{ error }}
    </div>
    <div class="form-actions" dir="ltr">
      <router-link 
      class="text-decoration-underline"
      :to="{name:'HealthInsurance'}">
        {{ t('common.previousPage') }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { http } from '@/services/http';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';


const router = useRouter();
const { t } = useI18n();
const loading = ref(true);
const error = ref(null);
const store = useStore();
const onIframeLoad = () => {
  loading.value = false;
};

const iframeUrl = ref(null);

const fetchIframeURL = async () => {
  try {
    const { data } = await http.get('fetch-iframe-url');
    if (data) {
      iframeUrl.value = data.url;
		}
  } catch (error) {
    if(error.status == 409){
      if(error?.data?.status == "pending"){
        router.replace({ name: 'ThankYouPage' });
      }else if(error?.data?.status == "success"){
        // router.replace({ name: 'SuccessPage' });
      }
    }
    console.log('failed to load URL:',error);
  }
}
const handleMessage = async (event) => {
  try {
    const allowedOrigins  = ['https://go-ins.co.il','https://www.go-ins.co.il']
    if (!allowedOrigins.includes(event.origin)) {
      console.log("Wrong origin:", event.origin);
      return;
    }
    console.log("origin is:", event.origin);
    let data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
    if (!data || !data.resultCode) {
      console.log("something wrong:", data);
      handleFailure(data);
      return; 
    }
    if (data.resultCode === "000") {
      await handleSuccess(data);
    } else {
      handleFailure(data);
    }
  } catch (err) {
    console.error('postMessage error:', err);
  }
};


const handleSuccess = async (data) => {
  try {
    await http.post('save-payment-token', data);

    router.replace({ name: 'ThankYouPage' });

  } catch (err) {
    if (err.response?.status === 422) {
      const validationErrors = err.response.data?.errors;
      if (validationErrors) {
        error.value = Object.values(validationErrors).flat().join(', ');
      } else {
        error.value = t('payment_page.errors.validation_error');
      }
    } else if (err.response?.status >= 500) {
      error.value = t('payment_page.errors.server_error');
    } else {
      error.value = t('payment_page.errors.payment_succeeded_but_failed_to_process');
    }
  }
};

const handleFailure = (data) => {
  console.warn('Payment failed:', data); // add this
  error.value = data.resultText || t('payment_page.errors.payment_failed_please_try_again');
};


onMounted(async () => {
  await store.dispatch('setLocale','he');
  window.addEventListener('message', handleMessage);
  fetchIframeURL();
});

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage);
});
</script>

<style scoped>
.payment-page iframe {
  border: 1px solid #ddd;
  border-radius: 8px;
}
</style>